import {HOUSE_ACTIONS, SUPPORT_ACTIONS} from "./types";
// import {shouldUpdate} from "ith-redux-helpers";
import {DELETE, GET, POST, PUT, UPLOAD} from "ith-fetch";
import {addError} from "./errorActions";
import {addProcessing, removeProcessing} from "./processingActions";
import {
	PROC_CLEAR_CACHE_METADATA,
	PROC_CREATE_HOUSE,
	PROC_DELETE_HOUSE,
	PROC_LOAD_HOUSES,
	PROC_MODULE_FOR_HOUSES, PROC_SUPPORT_LOGIN,
	PROC_UPDATE_HOUSE, PROC_UPLOAD_HOUSE_LOGO
} from "./index";
import isFunc from 'lodash/isFunction';

const _all = (list) => ({type: HOUSE_ACTIONS.LOAD_ALL, list});
const _one = (house) => ({type: HOUSE_ACTIONS.LOAD_ONE, house});
// const _remove = id => ({type: HOUSE_ACTIONS.REMOVE_ONE, id});
const _assign = (id, list) => ({type: HOUSE_ACTIONS.ASSIGN_MODULES, id, list});
const _revoke = (id, module_id) => ({type: HOUSE_ACTIONS.REVOKE_MODULES, id, module_id});
const _setKfz = (id, list, replace=false) => ({type: HOUSE_ACTIONS.SET_KFZ, id, list, replace});
const _removeLogo = id => ({type: HOUSE_ACTIONS.REMOVE_LOGO, id});

export const loadAllHouses = (onSuccess) =>
	async (dispatch) => {
		try {
			dispatch(addProcessing(PROC_LOAD_HOUSES));
			const list = await GET('/house/list');
			dispatch(_all(list));
			isFunc(onSuccess) && onSuccess(list);
		} catch (e) {
			dispatch(addError(e.message));
		} finally {
			dispatch(removeProcessing(PROC_LOAD_HOUSES));
		}
	};

export const loadHouse = (house_id, onSuccess) =>
	async dispatch => {
		try {
			const house = await GET(`/house/id/${house_id}`);
			dispatch(_one(house));
			isFunc(onSuccess) && onSuccess(house);
		} catch (e) {
			dispatch(addError(e.message));
		}
	};

export const updateHouse = (house, onSuccess) =>
	async dispatch => {
		try {
			dispatch(addProcessing(PROC_UPDATE_HOUSE));
			const result = await POST('/house', house);
			dispatch(_one(result.house));
			isFunc(onSuccess) && onSuccess(result);
		} catch (e) {
			dispatch(addError(e.message));
		} finally {
			dispatch(removeProcessing(PROC_UPDATE_HOUSE));
		}
	};

export const createHouse = (house, onSuccess) =>
	async dispatch => {
		try {
			dispatch(addProcessing(PROC_CREATE_HOUSE));
			const result = await PUT('/house', house);
			dispatch(_one(result.house));
			isFunc(onSuccess) && onSuccess(result);
			dispatch(loadHouse(result.house.house_id));
		} catch (e) {
			dispatch(addError(e.message));
		} finally {
			dispatch(removeProcessing(PROC_CREATE_HOUSE));
		}
	};

export const deleteHouse = (house_id, onSuccess) =>
	async dispatch => {
		try {
			// dispatch(addProcessing(PROC_DELETE_HOUSE, house_id));
			dispatch(addProcessing(PROC_UPDATE_HOUSE, house_id));
			const result = await DELETE(`/house/${house_id}`);
			dispatch(_one(result.house));
			isFunc(onSuccess) && onSuccess(result);
		} catch (e) {
			console.error(PROC_DELETE_HOUSE, e);
			dispatch(addError(e.message));
		} finally {
			dispatch(removeProcessing(PROC_UPDATE_HOUSE, house_id));
		}
	};

export const hasSupport = (house_id, callback) =>
	async dispatch => {
		try {
			const {ackownledged} = GET(`/support/${house_id}`);
			callback(ackownledged);
		} catch (e) {
			callback(false, e.message);
		}
	};

export const regenerateHouse = (house, onSuccess) =>
	async dispatch => {
		const house_id = house.house_id || house;
		try {
			dispatch(addProcessing(PROC_UPDATE_HOUSE, house_id));
			const result = await POST('/house/undelete/' + house_id);
			dispatch(_one(result.house));
			isFunc(onSuccess) && onSuccess(result);
		} catch (e) {
			dispatch(addError(e.message));
		} finally {
			dispatch(removeProcessing(PROC_UPDATE_HOUSE, house_id));
		}
	};

export const activateHouse = (house, active, onSuccess) =>
	async dispatch => {
		const house_id = house.house_id || house;
		try {
			dispatch(addProcessing(PROC_UPDATE_HOUSE, house_id));
			const result = await POST('/house/active', {house_id, active});
			dispatch(_one(result.house));
			isFunc(onSuccess) && onSuccess(result);
		} catch (e) {
			dispatch(addError(e.message));
		} finally {
			dispatch(removeProcessing(PROC_UPDATE_HOUSE, house_id));
		}
	};

export const fetchModulesOfHouse = (house, onSuccess) =>
	async dispatch => {
		const house_id = house.house_id || house;
		try {
			dispatch(addProcessing(PROC_MODULE_FOR_HOUSES, house_id));
			const result = await GET('/modules/house/' + house_id);
			dispatch(_assign(house_id, result.list));
			isFunc(onSuccess) && onSuccess(result);
		} catch (e) {
			dispatch(addError(e.message));
		} finally {
			dispatch(removeProcessing(PROC_MODULE_FOR_HOUSES, house_id));
		}
	};
export const revokeModuleFromHouse = (module, house, onSuccess) =>
	async dispatch => {
		const module_id = module.module_id || module;
		const house_id = house.house_id || house;
		try {
			dispatch(addProcessing(PROC_MODULE_FOR_HOUSES, house_id));
			const result = await POST('/modules/house/revoke', {module_id, house_id});
			dispatch(_revoke(house_id, module_id));
			isFunc(onSuccess) && onSuccess(result);
		} catch (e) {
			dispatch(addError(e.message));
		} finally {
			dispatch(removeProcessing(PROC_MODULE_FOR_HOUSES, house_id));
		}
	};
export const assignModuleToHouse = (module, house, onSuccess) =>
	async dispatch => {
		const house_id = house.house_id || house;
		const module_id = module.module_id || module;
		try {
			dispatch(addProcessing(PROC_MODULE_FOR_HOUSES, house_id));
			const result = await POST('/modules/house/assign', {house_id, module_id});
			dispatch(_assign(house_id, [result.relation]));
			isFunc(onSuccess) && onSuccess(result);
		} catch (e) {
			dispatch(addError(e.message));
		} finally {
			dispatch(removeProcessing(PROC_MODULE_FOR_HOUSES, house_id));
		}
	};

export const savePaymentOfHouse = (house, onSuccess) =>
	async dispatch => {
		try {
			dispatch(addProcessing(PROC_UPDATE_HOUSE, house.house_id));
			const result = await POST('/house/payment', house);
			dispatch(_one(result.house));
			isFunc(onSuccess) && onSuccess(result);
		} catch (e) {
			dispatch(addError(e.message));
		} finally {
			dispatch(removeProcessing(PROC_UPDATE_HOUSE, house.house_id));
		}
	};
export const fetchKfzOfHouse = (house, onSuccess) =>
	async dispatch => {
		const house_id = house.house_id || house;
		try {
			dispatch(addProcessing(PROC_UPDATE_HOUSE, house_id));
			const result = await GET('/house/kfz/' + house_id);
			dispatch(_setKfz(house_id, result.list));
			isFunc(onSuccess) && onSuccess(result);
		} catch (e) {
			dispatch(addError(e.message));
		} finally {
			dispatch(removeProcessing(PROC_UPDATE_HOUSE, house_id));
		}
	};
export const updateKfzOfHouse = (house, kfz_list, onSuccess) =>
	async dispatch => {
		const house_id = house.house_id || house;
		try {
			dispatch(addProcessing(PROC_UPDATE_HOUSE, house_id));
			const result = await POST('/house/kfz/' + house_id, kfz_list);
			dispatch(_setKfz(house_id, result.list, true));
			isFunc(onSuccess) && onSuccess(result);
		} catch (e) {
			dispatch(addError(e.message));
		} finally {
			dispatch(removeProcessing(PROC_UPDATE_HOUSE, house_id));
		}
	};
export const uploadLogoForHouse = (house, image, onSuccess) =>
	async dispatch => {
		const house_id = house.house_id || house;
		const data = new FormData();
		data.append('file', image);
		try {
			dispatch(addProcessing(PROC_UPLOAD_HOUSE_LOGO, house_id));
			const result = await UPLOAD('/house/logo/'+house_id, data);
			dispatch(_one(result.house));
			isFunc(onSuccess) && onSuccess(result);
		} catch (e) {
			dispatch(addError(e.message));
		} finally {
			dispatch(removeProcessing(PROC_UPLOAD_HOUSE_LOGO, house_id));
		}
	};
export const removeLogoOfHouse = (house, onSuccess) =>
	async dispatch => {
		const house_id = house.house_id || house;
		try {
			dispatch(addProcessing(PROC_UPDATE_HOUSE, house_id));
			const result = await DELETE('/house/logo/'+house_id);
			dispatch(_removeLogo(result.house_id || house_id));
			isFunc(onSuccess) && onSuccess(result);
		} catch (e) {
			dispatch(addError(e.message));
		} finally {
			dispatch(removeProcessing(PROC_UPDATE_HOUSE, house_id));
		}
	};

export const loginAsSupport = (house, onSuccess) =>
	async dispatch => {
		const house_id = house.house_id || house;
		try {
			dispatch(addProcessing(PROC_SUPPORT_LOGIN, house_id));
			await POST(`/support/${house_id}`);
			isFunc(onSuccess) && onSuccess();
			dispatch({type: SUPPORT_ACTIONS.SET, value: house_id});
		} catch (e) {
			dispatch(addError(e));
		} finally {
			dispatch(removeProcessing(PROC_SUPPORT_LOGIN, house_id));
		}
	};
export const loginAsWorker = (worker) => GET(`/workers/login/${worker.workers_id || worker}`);
export const resetSupportLogin = () => dispatch => dispatch({type: SUPPORT_ACTIONS.SET, value: null});
export const fetchActiveWorkersCount = (house, onSuccess) =>
	async dispatch => {
		const house_id = house.house_id || house;
		try {
			const count = await GET(`/house/${house_id}/active_workers`);
			isFunc(onSuccess) && onSuccess(count);
			dispatch({type: HOUSE_ACTIONS.GET_ACTIVE_WORKERS, house_id, count});
		} catch (e) {
			dispatch(addError(e));
		}
	};
export const clearMetadataCache = (onSuccess) =>
	async dispatch => {
		try {
			dispatch(addProcessing(PROC_CLEAR_CACHE_METADATA));
			const result = await GET('/clear/cache/metadata');
			isFunc(onSuccess) && onSuccess(result);
		} catch (e) {
			dispatch(addError(e));
		} finally {
			dispatch(removeProcessing(PROC_CLEAR_CACHE_METADATA));
		}
	};
export const houseCall__fetchWorkers = house => GET(`/workers/${house.house_id || house}`);


// WEBPACK FOOTER //
// ./src/actions/houseActions.js